import toLocalTimeNoThrow from '../time/toLocalTimeNoThrow';

export default {
  type: 'test',
  name: 'is-valid-time',
  test: (value: any): boolean => toLocalTimeNoThrow(value) ? true : false,
};
